import { render, staticRenderFns } from "./Seitenzahlen.vue?vue&type=template&id=a956f2d2&"
import script from "./Seitenzahlen.vue?vue&type=script&lang=js&"
export * from "./Seitenzahlen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports